<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="600"
      scrollable
      v-if="hasAlternatives"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text x-small color="primary" dark v-bind="attrs" v-on="on">
          {{ btnText }}
        </v-btn>
      </template>
      <v-card color="white" class="">
        <v-card-title class="d-flex flex-row orangeCardTitle">
          <div>Alternatives Rxs</div>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon small
            ><v-icon color="primary" small>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text class="pt-4 darkerCardText text-center">
          <b>Are any of these the Rx you were looking for?</b>
          <div class="caption">Click the correct Rx for each eye.</div>
          <div class="d-flex flex-row flex-wrap">
            <!-- OK, how about these? <br />Click the desired Rx. -->
            <!-- <div
              v-for="(pair, i) in rxAlternatives"
              :key="i"
              class="d-flex flex-row flex-wrap pointer"
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    class="pointer ma-2 pa-2"
                    outlined
                    color="#f5f5f5"
                    @click="setRxs(pair)"
                    :elevation="hover ? 1 : 0"
                    :class="{ blue: hover }"
                  >
                    <rx-formatted
                      :rxPair="pair"
                    ></rx-formatted> </v-card></template
              ></v-hover>
            </div> -->
          </div>

          <!-- <input
                type="radio"
                :id="'radio' + eye + '0'"
                v-model="selection[eye]"
                :value="null"
              />
              <label :for="'radio' + eye + '0'">No Rx</label> -->

          <div class="d-inline-block text-center">
            <table class="borderedTable my-4 mx-2" style="min-width: 300px">
              <tr>
                <th class="overline odHeaderBackground">OD Rx</th>
                <td class="overline" style="background-color: #f6feff">Rx</td>
                <th class="overline osHeaderBackground">OS Rx</th>
              </tr>
              <tr>
                <td class="odBackground">
                  <input
                    type="radio"
                    v-model="selectionIndex.od"
                    :value="null"
                  />
                </td>
                <th>No Rx</th>
                <td class="osBackground">
                  <input
                    type="radio"
                    v-model="selectionIndex.os"
                    :value="null"
                  />
                </td>
              </tr>
              <tr v-for="(rx, i) in rxAlternatives" :key="i">
                <td class="odBackground">
                  <input type="radio" v-model="selectionIndex.od" :value="i" />
                </td>
                <th>
                  {{ rx.string }}
                </th>
                <td class="osBackground">
                  <input type="radio" v-model="selectionIndex.os" :value="i" />
                </td>
              </tr>
            </table>

            <div v-if="!noAdd" class="addDiv">
              <!-- <v-checkbox
                v-model="bifocal_cbx"
                class="ml-2"
                label="Add power options"
              ></v-checkbox> -->
              <!-- <v-radio-group v-model="bifocal_cbx" row>
                <v-radio label="No Add" :value="false"></v-radio>
                <v-radio label="Include Add" :value="true"></v-radio>
              </v-radio-group> -->

              <div class="ml-4 mb-4">
                <v-combobox
                  :items="addOptions"
                  label="Add"
                  dense
                  outlined
                  filled
                  clearable
                  background-color="#FFF"
                  hide-details
                  item-value="value"
                  item-text="text"
                  :return-object="false"
                  v-model="add_select"
                ></v-combobox>
                <v-expand-transition>
                  <v-radio-group
                    v-if="!noDominant && add_select"
                    v-model="dominant_radio"
                    class="mt-2"
                    label="Dominant Eye"
                    row
                    hide-details
                  >
                    <v-radio value="od" label="OD"></v-radio>
                    <v-radio value="os" label="OS"></v-radio>
                  </v-radio-group>
                </v-expand-transition>
              </div>
            </div>
            <!-- <v-btn text small color="primary" @click="dialog = false"
              >Cancel</v-btn
            > -->
            <v-btn
              @click="emitRxs()"
              color="primary"
              small
              depressed
              :disabled="selectionIndex.od == null && selectionIndex.os == null"
            >
              Use Selected Rxs</v-btn
            >
          </div>

          <v-divider class="my-4"></v-divider>

          <div v-if="rxText" class="mt-3">
            <div>
              <b>OR, If none of the above are correct..</b>
              <div class="caption">
                Review the text below. Can it be cleaned up? Is there any
                extraneous data (perhaps numbers for prism, VAs, PDs, etc) that
                may be confusing me?
              </div>
            </div>
            <v-textarea
              v-model="newText"
              outlined
              placeholder="Type or paste something to search for"
              clearable
              @keyup="edited = true"
            ></v-textarea>
            <v-btn
              :disabled="!edited"
              depressed
              small
              color="primary"
              @click="emitNewText()"
              >Search</v-btn
            >
          </div>

          <!-- <v-btn @click="dialog = false" small depressed outlined>Cancel</v-btn> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
// import RxFormatted from "@/components/clStuff/RxFormatted";

export default {
  name: "RxParserAlternatives",
  components: {
    // RxFormatted,
  },
  mixins: [RxMethods],
  props: {
    open: null,
    rxText: null,
    rxAlternatives: null,
    noAdd: null, // if true, will not show add options
    noDominant: null, // if true, will not show dominant eye options
    btnText: {
      type: String,
      default: "Is this the wrong Rx?",
    },
  },
  data: function () {
    return {
      dialog: false,
      newText: null,
      edited: false,
      // bifocal_cbx: false,
      add_select: null,
      dominant_radio: "od",
      selectionIndex: { od: 0, os: 1 },
      addOptions: [
        // can I make the values numbers?
        { text: "No Add", value: null },
        { text: "+0.25", value: "+0.25" },
        { text: "+0.50", value: "+0.50" },
        { text: "+0.75", value: "+0.75" },
        { text: "+1.00", value: "+1.00" },
        { text: "+1.25", value: "+1.25" },
        { text: "+1.50", value: "+1.50" },
        { text: "+1.75", value: "+1.75" },
        { text: "+2.00", value: "+2.00" },
        { text: "+2.25", value: "+2.25" },
        { text: "+2.50", value: "+2.50" },
        { text: "+2.75", value: "+2.75" },
        { text: "+3.00", value: "+3.00" },
      ],
    };
  },
  methods: {
    // setRxs(pair) {
    //   this.$emit("newRxs", pair);
    //   this.dialog = false;
    // },
    emitRxs() {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let rxAltIndex = this.selectionIndex[eye];
        if (rxAltIndex === null) {
          rtn[eye] = null;
        } else {
          rtn[eye] = this.rxAlternatives[rxAltIndex];
          if (!this.noAdd && this.add_select) rtn[eye].add = this.add_select;
        }
      });

      if (rtn[this.dominant_radio]) rtn[this.dominant_radio].dominant = true;
      this.$emit("newRxs", rtn);
      this.dialog = false;
    },
    emitNewText() {
      this.$emit("newText", this.newText);
      this.dialog = false;
    },
    findAdds() {
      if (!this.rxAlternatives) return null;
      // console.log(this.rxAlternatives);
      if (
        this.rxAlternatives[0]?.add &&
        parseFloat(this.rxAlternatives[0].add) > 0
      ) {
        this.bifocal_cbx = true;
      }
      let add = null;
      this.rxAlternatives.forEach((rx) => {
        if (rx.add && !add) add = rx.add;
      });
      this.add_select = add;
    },
  },
  computed: {
    hasAnAdd() {
      this.rxAlternatives.forEach((rx) => {
        if (rx.add) return true;
      });
      return false;
    },
    hasAlternatives() {
      return this.rxAlternatives && this.rxAlternatives.length > 1;
    },
  },
  mounted() {
    this.newText = this.rxText;
    this.findAdds();
  },
  watch: {
    rxAlternatives: {
      handler: function () {
        this.findAdds();
      },
      deep: true,
    },
    // add(val) {
    //   if (this.bifocal_cbx && val) {
    //     if (this.selection.od) this.selection.od.add = val;
    //     if (this.selection.os) this.selection.os.add = val;
    //   }
    // },
    // dominant_radio(val) {
    //   if (this.bifocal_cbx && val) {
    //     let otherEye = val == "od" ? "os" : "od";
    //     if (this.selection[val]) this.selection[val].dominant = 1;
    //     if (this.selection[otherEye]) this.selection[otherEye].dominant = 0;
    //   }
    // },
    // bifocal_cbx(val) {
    //   if (!val) {
    //     if (this.selection.od) this.selection.od.add = null;
    //     if (this.selection.os) this.selection.os.add = null;
    //   }
    // },
  },
};
</script>

<style scoped>
.blue {
  background-color: rgb(230, 239, 255) !important;
}

input[type="radio"] {
  transform: scale(1.5);
}

table {
  border-spacing: 0;
  border-collapse: collapse;
}
table td,
table th {
  border: 1px solid #ddd;
  padding: 4px 8px;
  text-align: center;
}
.addDiv >>> .v-input--radio-group__input {
  justify-content: center;
}
</style>
